import { render, staticRenderFns } from "./lecture.vue?vue&type=template&id=3873be8a&scoped=true"
import script from "./lecture.vue?vue&type=script&lang=js"
export * from "./lecture.vue?vue&type=script&lang=js"
import style0 from "./lecture.vue?vue&type=style&index=0&id=3873be8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3873be8a",
  null
  
)

export default component.exports